import { render, staticRenderFns } from "./detailModal.vue?vue&type=template&id=40077a01"
import script from "./detailModal.vue?vue&type=script&lang=js"
export * from "./detailModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40077a01')) {
      api.createRecord('40077a01', component.options)
    } else {
      api.reload('40077a01', component.options)
    }
    module.hot.accept("./detailModal.vue?vue&type=template&id=40077a01", function () {
      api.rerender('40077a01', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/GpsViews/Admin/ShippingInstructions/detailModal.vue"
export default component.exports